import { http } from "shared/api/http";

const apiBase = process.env.REACT_APP_API_BASE_URL;

export const requestPasswordReset = async () => {
  const res = await http.post(`${apiBase}/api/v1/auth/request-password-reset`);
  return res?.data;
};

export const requestEmailChange = async (newEmail: string) => {
  const res = await http.post(`${apiBase}/api/v1/auth/change-email`, { newEmail });
  return res?.data;
};
